import React from "react"
import PropTypes from "prop-types"
import SyntaxHighlighter from "react-syntax-highlighter"
import { tomorrow } from "react-syntax-highlighter/dist/styles/prism"

export interface CodeHighlighterProps {
  code: string
}

export default function CodeHighlighter({ code }: CodeHighlighterProps) {
  return (
    <SyntaxHighlighter language="javascript" style={tomorrow} wrapLines showLineNumbers>
      {code}
    </SyntaxHighlighter>
  )
}

CodeHighlighter.propTypes = {
  code: PropTypes.string.isRequired
}
